import { tutorialAssets } from "assets/cdn";
import { useImagePath } from "hooks/useImagePath";
import { Flag } from "pages/StoreFront/lib/OfferCardV2/lib/Flag/svg";
import {
	Discount,
	DiscountViewport,
	Ribbon,
	RibbonContent,
	RibbonShine,
	RibbonTicker
} from "./styles";

interface TutorialRibbonProps {
	left: number;
	top: number;
}

export const TutorialRibbon = ({ left, top }: TutorialRibbonProps) => {
	const { getImage } = useImagePath("cdn");
	const ShineImage = getImage(tutorialAssets.shine);
	return (
		<Ribbon $left={left} $top={top} aria-hidden="true">
			<RibbonShine src={ShineImage} />
			<Flag />
			<RibbonContent>
				<DiscountViewport>
					<RibbonTicker>
						<Discount>10%</Discount>
						<Discount>13%</Discount>
						<Discount>15%</Discount>
						<Discount>10%</Discount>
					</RibbonTicker>
				</DiscountViewport>
				<span>MORE!</span>
			</RibbonContent>
		</Ribbon>
	);
};
